import React from 'react';
import {
    Box, IconButton, Typography, Card, Divider, Button,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { saveToIndexedDB } from './indexedDBUtils';

const Cart = ({
                  cartItems,
                  onRemoveItem,
                  onIncreaseQuantity,
                  onDecreaseQuantity,
                  onClose,
                  onClearCart
              }) => {
    const calculateTotalPrice = () => {
        return cartItems.reduce((total, item) => {
            const price = parseFloat(String(item.price).replace(/Rs[:\s]*/, '')) || 0;
            return total + price * item.quantity;
        }, 0);
    };

    const getTotalQuantity = () => {
        return cartItems.reduce((sum, item) => sum + item.quantity, 0);
    };

    const printBill = async () => {
        let lastOrderId = parseInt(localStorage.getItem('lastOrderId'), 10) || 0;
        const newOrderId = lastOrderId + 1;
        localStorage.setItem('lastOrderId', newOrderId.toString());

        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString();
        const formattedTime = currentDate.toLocaleTimeString();

        const bill = {
            _id: `order-${newOrderId}`,
            orderId: newOrderId,
            items: cartItems,
            total: calculateTotalPrice().toFixed(2),
            timestamp: currentDate.toISOString(),
        };

        try {
            await saveToIndexedDB(bill);
        } catch (error) {
            console.error('Failed to save order to IndexedDB:', error);
        }

        const billHistory = JSON.parse(localStorage.getItem('billHistory')) || [];
        billHistory.push(bill);
        localStorage.setItem('billHistory', JSON.stringify(billHistory));
        localStorage.setItem('lastPrintedBill', JSON.stringify(bill));

        const billContent = `
        <html>
        <head>
            <title>Invoice</title>
            <style>
                * {
                    box-sizing: border-box;
                }
                body {
                    font-family: 'Segoe UI', sans-serif;
                    margin: 0;
                    padding: 0;
                }
                .invoice-box {
                    width: 80mm;
                    padding: 8px;
                    margin: 0 auto;
                    font-size: 10px;
                    line-height: 1.2;
                    /*border: 1px solid #000;*/
                }
                .header {
                    text-align: center;
                    margin-bottom: 8px;
                }
                .items, .items th, .items td {
                    width: 100%;
                    border-collapse: collapse;
                    border-bottom: 1px dashed #000;
                }
                .items th, .items td {
                    padding: 2px 4px;
                    text-align: left;
                }
                .items td:nth-child(2), .items th:nth-child(2) {
                    text-align: center;
                }
                .items td:nth-child(3), .items th:nth-child(3),
                .items td:nth-child(4), .items th:nth-child(4) {
                    text-align: right;
                }
                .total {
                    margin-top: 8px;
                    text-align: right;
                    font-weight: bold;
                    font-size: 12pt;
                }
                .footer {
                    margin-top: 10px;
                    text-align: center;
                    font-size: 9px;
                }
                .review-box {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: 10px;
                    padding-top: 6px;
                    border-top: 1px dashed #000;
                }
                .review-text {
                    font-size: 8px;
                }
                .qr-img {
                    width: 60px;
                    height: 60px;
                    object-fit: contain;
                }
              @media print {
    @page {
        margin: 5mm;
        size: auto;
    }
    body {
        margin: 0;
        padding: 0;
        font-size: 8pt !important;
        line-height: 1.1 !important;
    }
    .invoice-box {
        width: 75mm !important;
        padding: 5px !important;
        font-size: 8pt !important;
        line-height: 1.1 !important;
        page-break-inside: avoid !important;
        overflow: visible !important;
    }
    .items {
        width: 100%;
        border-collapse: collapse;
    }
    .items th,
    .items td {
        padding: 2px 4px;
        border-bottom: 1px dashed #000 !important; /* keep dashed line */
        font-size: 8pt !important;
        white-space: nowrap;
    }
    .items tr:last-child td {
        border-bottom: none !important; /* remove dash after last row */
    }
    .review-box {
        border-top: 1px dashed #000 !important; /* keep dashed border on review section */
        padding-top: 5px;
        margin-top: 5px;
    }
    .footer {
        font-size: 7pt !important;
        margin-top: 5px;
    }
}

            </style>
        </head>
        <body>
            <div class="invoice-box">
                <div class="header">
                    <h2 style="margin: 0;"># INVOICE</h2> 
                    <h3 style="margin: 0;">Chickago Restaurant</h3>
                    <p style="margin: 4px 0;">Galle Branch | Karapitiya Branch</p>
                    <p style="margin: 4px 0;">Contact: +94 76 328 9880</p>
                    <div style="display: flex; justify-content: space-between; font-size: 9px;">
                        <span>Date: ${formattedDate} | Time: ${formattedTime}</span>
                        <strong>Order ID: ${newOrderId}</strong>
                    </div>
                </div>
                <table class="items">
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th>Qty</th>
                            <th>Price</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${cartItems.map(item => {
            const price = parseFloat(String(item.price).replace(/Rs[:\s]*/, '')) || 0;
            return `
                                <tr>
                                    <td>${item.name}</td>
                                    <td>${item.quantity}</td>
                                    <td>${item.price}</td>
                                    <td>${(price * item.quantity).toFixed(2)}</td>
                                </tr>
                            `;
        }).join('')}
                    </tbody>
                </table>
                <div class="total">Total: Rs ${calculateTotalPrice().toFixed(2)}</div>
                <div class="footer">
                    <p>Thank you! Come Again ❤️</p>
                </div>
                <div class="review-box">
                    <div class="review-text">
                        <p><strong>Leave your review!</strong></p>
                        <p>Scan this QR:</p>
                    </div>
                    <img class="qr-img" src="${window.location.origin}/qr-img.png" alt="QR Code" />
                </div>
            </div>
            <script>
                window.onload = function() {
                    window.print();
                };
            </script>
        </body>
        </html>
    `;

        const printWindow = window.open('', '_blank', 'width=800,height=600');
        printWindow.document.open();
        printWindow.document.write(billContent);
        printWindow.document.close();
        onClearCart();
        onClose();

    };


    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 16,
                right: 16,
                width: 350,
                // maxHeight: '80vh',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'white',
                boxShadow: 3,
                borderRadius: 2,
                p: 2,
                zIndex: 1300,
                overflow: 'hidden'
            }}
        >
            <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8 }}>
                <CloseIcon />
            </IconButton>
            <Typography variant="h6" gutterBottom>
                Cart ({getTotalQuantity()})
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Box sx={{ flex: 1, overflowY: 'auto', px: 1 }}>
                {cartItems.length === 0 ? (
                    <Typography>No items in the cart.</Typography>
                ) : (
                    cartItems.map((item, index) => (
                        <Card key={index} sx={{ mb: 1, p: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography variant="subtitle1" noWrap>
                                        {item.name}
                                    </Typography>
                                    <Typography variant="caption">
                                        Total: Rs {(parseFloat(String(item.price).replace(/Rs[:\s]*/, '')) * item.quantity).toFixed(2)}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        sx={{ minWidth: 32, px: 1 }}
                                        onClick={() => onDecreaseQuantity(index)}
                                        disabled={item.quantity <= 1}
                                    >
                                        -
                                    </Button>
                                    <Typography sx={{ minWidth: 20, textAlign: 'center' }}>{item.quantity}</Typography>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        sx={{ minWidth: 32, px: 1 }}
                                        onClick={() => onIncreaseQuantity(index)}
                                    >
                                        +
                                    </Button>
                                    <Button
                                        variant="text"
                                        size="small"
                                        color="error"
                                        sx={{ ml: 2, fontSize: '0.75rem' }}
                                        onClick={() => onRemoveItem(index)}
                                    >
                                        Remove
                                    </Button>
                                </Box>
                            </Box>
                        </Card>
                    ))
                )}
            </Box>

            <Box sx={{ pt: 1, borderTop: '1px solid #ccc' }}>
                <Typography variant="h6" sx={{ mt: 1 }}>
                    Total Price: Rs {calculateTotalPrice().toFixed(2)}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Button
                        variant="contained"
                        sx={{ backgroundColor: 'orange' }}
                        onClick={printBill}
                    >
                        Proceed
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default Cart;
